var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_13422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 17.9583H7.9375C6.89208 17.9583 6.04167 17.1079 6.04167 16.0625V12.2708C6.04167 11.2254 6.89208 10.375 7.9375 10.375H13.3542C13.6873 10.375 14.015 10.4628 14.3021 10.6285C14.4315 10.7038 14.5973 10.6588 14.672 10.5299C14.7473 10.4005 14.7029 10.2347 14.5735 10.16C14.444 10.0852 14.307 10.0278 14.1672 9.97796V9.02083C14.1672 7.0795 12.5877 5.5 10.6464 5.5C8.70504 5.5 7.125 7.0795 7.125 9.02083V9.98283C6.18142 10.3192 5.5 11.213 5.5 12.2708V16.0625C5.5 17.4064 6.59363 18.5 7.9375 18.5H11.1875C11.337 18.5 11.4583 18.3787 11.4583 18.2292C11.4583 18.0797 11.337 17.9583 11.1875 17.9583ZM7.66667 9.02083C7.66667 7.37796 9.00296 6.04167 10.6458 6.04167C12.2887 6.04167 13.625 7.37796 13.625 9.02083V9.85121C13.5351 9.84146 13.4452 9.83333 13.3542 9.83333H7.9375C7.84488 9.83333 7.75658 9.85067 7.66667 9.86096V9.02083ZM10.6458 13.625C10.7953 13.625 10.9167 13.7463 10.9167 13.8958V14.9792C10.9167 15.1287 10.7953 15.25 10.6458 15.25C10.4963 15.25 10.375 15.1287 10.375 14.9792V13.8958C10.375 13.7463 10.4963 13.625 10.6458 13.625ZM14.9792 11.4583C13.0378 11.4583 11.4583 13.0378 11.4583 14.9792C11.4583 16.9205 13.0378 18.5 14.9792 18.5C16.9205 18.5 18.5 16.9205 18.5 14.9792C18.5 13.0378 16.9205 11.4583 14.9792 11.4583ZM14.9792 17.9583C13.3363 17.9583 12 16.6215 12 14.9792C12 13.3368 13.3363 12 14.9792 12C16.622 12 17.9583 13.3368 17.9583 14.9792C17.9583 16.6215 16.622 17.9583 14.9792 17.9583ZM16.7938 14.2441C16.8978 14.3514 16.895 14.5231 16.7873 14.6271L15.3231 16.043C15.1281 16.2353 14.8708 16.3317 14.613 16.3317C14.3552 16.3317 14.099 16.2358 13.9023 16.0441L13.1635 15.3145C13.0568 15.2099 13.0557 15.0382 13.1608 14.9315C13.2659 14.8259 13.4376 14.8243 13.5438 14.9293L14.282 15.6579C14.4646 15.8366 14.762 15.8345 14.9445 15.6557L16.4103 14.2376C16.5186 14.1342 16.6903 14.1363 16.7938 14.2441Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_13422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "currentColor",
    transform: "translate(5.5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/Auth.95620fc39f12817164bacd19ce4fcfdf.svg";
export { ForwardRef as ReactComponent };